import { render, staticRenderFns } from "./productManage.vue?vue&type=template&id=d4c79c50&scoped=true"
import script from "./productManage.vue?vue&type=script&lang=js"
export * from "./productManage.vue?vue&type=script&lang=js"
import style0 from "./productManage.vue?vue&type=style&index=0&id=d4c79c50&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4c79c50",
  null
  
)

export default component.exports